import React from 'react';
import { useFormContext } from 'react-hook-form';

const Step3Address: React.FC = () => {
  const { register, formState: { errors } } = useFormContext();

  return (
    <div className="solar-form-section">
      <div className="solar-form-group">
        <label htmlFor="address" className="solar-form-label">
          Street Address
        </label>
        <input
          type="text"
          id="address"
          {...register('address')}
          className="solar-form-input"
        />
        {errors.address && (
          <p className="solar-form-error">{String(errors.address.message)}</p>
        )}
      </div>

      <div className="solar-form-grid">
        <div className="solar-form-group">
          <label htmlFor="city" className="solar-form-label">
            City
          </label>
          <input
            type="text"
            id="city"
            {...register('city')}
            className="solar-form-input"
          />
          {errors.city && (
            <p className="solar-form-error">{String(errors.city.message)}</p>
          )}
        </div>

        <div className="solar-form-group">
          <label htmlFor="state" className="solar-form-label">
            State
          </label>
          <input
            type="text"
            id="state"
            {...register('state')}
            className="solar-form-input"
          />
          {errors.state && (
            <p className="solar-form-error">{String(errors.state.message)}</p>
          )}
        </div>
      </div>

      <div className="solar-form-group">
        <label htmlFor="zipCode" className="solar-form-label">
          ZIP Code
        </label>
        <input
          type="text"
          id="zipCode"
          {...register('zipCode')}
          className="solar-form-input"
        />
        {errors.zipCode && (
          <p className="solar-form-error">{String(errors.zipCode.message)}</p>
        )}
      </div>
    </div>
  );
};

export default Step3Address; 